module.exports = "/assets/0a3d04d01783be0397f885a71f78ed53.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/E6.png
// module id = 1325
// module chunks = 0